// transformed suggest content with new price propType (v3)
import { arrayOf, shape, string } from 'prop-types'

import Price_v1 from './Price_v1'

export default {
  id: string,
  prices: arrayOf(shape(Price_v1)),
  thumbnailURL: string,
  name: string,
}
